import dynamic from 'next/dynamic';

export default dynamic(() => import('./StaticDateTimeRangePickerInternal'), { ssr: false });
